export const WHITE_PRINT_ADD = {
  name: '백색인쇄추가',
  bp_option_group_name: '백색인쇄추가',
  dependency_bp_option_group_name: '재질',
};
